import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { CheckboxGroup } from '../ui/CheckboxGroup';
import { FileUpload } from '../ui/FileUpload';
import { MascotPanel } from '../ui/MascotPanel';
export function Step6Legal() {
  const {
    data,
    updateData
  } = useIntake();
  const legalDocOptions = [{
    value: 'algemene_voorwaarden',
    label: 'Algemene Voorwaarden'
  }, {
    value: 'privacyverklaring',
    label: 'Privacyverklaring'
  }, {
    value: 'cookiebeleid',
    label: 'Cookiebeleid'
  }, {
    value: 'disclaimer',
    label: 'Disclaimer'
  }, {
    value: 'retourbeleid',
    label: 'Retourbeleid'
  }, {
    value: 'garantiebeleid',
    label: 'Garantiebeleid'
  }, {
    value: 'klachtenprocedure',
    label: 'Klachtenprocedure'
  }, {
    value: 'leveringsvoorwaarden',
    label: 'Leveringsvoorwaarden'
  }, {
    value: 'verwerkersovereenkomst',
    label: 'Verwerkersovereenkomst'
  }, {
    value: 'servicevoorwaarden',
    label: 'Servicevoorwaarden / SLA'
  }, {
    value: 'overig',
    label: 'Overige documenten'
  }];
  const handleDocUpload = (docValue: string, url: string) => {
    updateData({
      legalDocs: {
        ...data.legalDocs,
        [docValue]: {
          file: url,
          text: '',
          status: 'uploaded'
        }
      }
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-451">
      <MascotPanel message="Een website moet niet alleen mooi zijn, maar ook juridisch kloppen. Heeft u al documenten zoals algemene voorwaarden of een privacyverklaring?" data-id="element-452" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-453">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-454">Juridische Zaken</h2>

        <div data-id="element-455">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-456">
            Zijn er juridische documenten die op de website moeten komen?
          </label>
          <RadioGroup columns={1} value={data.hasLegalDocs} onChange={val => updateData({
          hasLegalDocs: val
        })} options={[{
          value: 'yes',
          label: 'Ja, ik heb deze documenten al'
        }, {
          value: 'no',
          label: 'Nee, ik moet deze nog (laten) opstellen'
        }]} data-id="element-457" />
        </div>

        <AnimatePresence data-id="element-458">
          {data.hasLegalDocs === 'yes' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 overflow-hidden pt-4 border-t border-gray-100" data-id="element-459">
              <div data-id="element-460">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-461">
                  Welke documenten heeft u beschikbaar?
                </label>
                <CheckboxGroup columns={2} options={legalDocOptions} values={data.legalDocsList} onChange={vals => updateData({
              legalDocsList: vals
            })} data-id="element-462" />
              </div>

              {data.legalDocsList.length > 0 && <div className="space-y-6 mt-6" data-id="element-463">
                  <h3 className="font-semibold text-gray-900" data-id="element-464">
                    Upload uw documenten
                  </h3>
                  {data.legalDocsList.map(docValue => {
              const docLabel = legalDocOptions.find(o => o.value === docValue)?.label;
              return <div key={docValue} className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-465">
                        <FileUpload label={docLabel} accept=".pdf,.doc,.docx" value={data.legalDocs[docValue]?.file} onChange={url => handleDocUpload(docValue, url)} data-id="element-466" />
                      </div>;
            })}
                </div>}
            </motion.div>}

          {data.hasLegalDocs === 'no' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 overflow-hidden pt-4 border-t border-gray-100" data-id="element-467">
              <div data-id="element-468">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-469">
                  Hoe wilt u dit aanpakken?
                </label>
                <RadioGroup columns={1} value={data.legalDocsApproach} onChange={val => updateData({
              legalDocsApproach: val
            })} options={[{
              value: 'noord',
              label: 'Noord Digital helpt mij hierbij',
              description: 'Wij zorgen voor juridisch correcte documenten'
            }, {
              value: 'advisor',
              label: 'Ik schakel zelf een juridisch adviseur in'
            }, {
              value: 'self',
              label: 'Ik stel ze zelf op'
            }]} data-id="element-470" />
              </div>

              <div data-id="element-471">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-472">
                  Welke documenten heeft u nodig?
                </label>
                <CheckboxGroup columns={2} options={legalDocOptions} values={data.legalDocsNeeded} onChange={vals => updateData({
              legalDocsNeeded: vals
            })} data-id="element-473" />
              </div>
            </motion.div>}
        </AnimatePresence>

        <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-474">
          <h3 className="font-semibold text-gray-900 mb-4" data-id="element-475">
            Welke documenten zijn vaak nodig?
          </h3>
          <ul className="space-y-3 text-sm text-gray-700" data-id="element-476">
            <li className="flex items-start" data-id="element-477">
              <span className="text-[#007AFF] mr-2" data-id="element-478">•</span>
              <span data-id="element-479">
                <strong data-id="element-480">Privacyverklaring:</strong> Verplicht als u een
                contactformulier heeft of analytics gebruikt.
              </span>
            </li>
            <li className="flex items-start" data-id="element-481">
              <span className="text-[#007AFF] mr-2" data-id="element-482">•</span>
              <span data-id="element-483">
                <strong data-id="element-484">Cookiebeleid:</strong> Verplicht bij gebruik van
                tracking cookies.
              </span>
            </li>
            <li className="flex items-start" data-id="element-485">
              <span className="text-[#007AFF] mr-2" data-id="element-486">•</span>
              <span data-id="element-487">
                <strong data-id="element-488">Algemene Voorwaarden:</strong> Sterk aanbevolen voor uw
                dienstverlening.
              </span>
            </li>
            <li className="flex items-start" data-id="element-489">
              <span className="text-[#007AFF] mr-2" data-id="element-490">•</span>
              <span data-id="element-491">
                <strong data-id="element-492">Disclaimer:</strong> Beschermt u tegen aansprakelijkheid
                voor informatie op de website.
              </span>
            </li>
            <li className="flex items-start" data-id="element-493">
              <span className="text-[#007AFF] mr-2" data-id="element-494">•</span>
              <span data-id="element-495">
                <strong data-id="element-496">Retourbeleid:</strong> Verplicht voor webshops
                (herroepingsrecht).
              </span>
            </li>
            <li className="flex items-start" data-id="element-497">
              <span className="text-[#007AFF] mr-2" data-id="element-498">•</span>
              <span data-id="element-499">
                <strong data-id="element-500">Garantiebeleid:</strong> Aanbevolen als u producten
                verkoopt.
              </span>
            </li>
            <li className="flex items-start" data-id="element-501">
              <span className="text-[#007AFF] mr-2" data-id="element-502">•</span>
              <span data-id="element-503">
                <strong data-id="element-504">Klachtenprocedure:</strong> Verplicht voor bepaalde
                branches (bijv. zorg, financieel).
              </span>
            </li>
            <li className="flex items-start" data-id="element-505">
              <span className="text-[#007AFF] mr-2" data-id="element-506">•</span>
              <span data-id="element-507">
                <strong data-id="element-508">Leveringsvoorwaarden:</strong> Belangrijk bij fysieke
                producten of diensten met levertijden.
              </span>
            </li>
            <li className="flex items-start" data-id="element-509">
              <span className="text-[#007AFF] mr-2" data-id="element-510">•</span>
              <span data-id="element-511">
                <strong data-id="element-512">Verwerkersovereenkomst:</strong> Nodig als u
                persoonsgegevens deelt met derden.
              </span>
            </li>
            <li className="flex items-start" data-id="element-513">
              <span className="text-[#007AFF] mr-2" data-id="element-514">•</span>
              <span data-id="element-515">
                <strong data-id="element-516">Servicevoorwaarden / SLA:</strong> Voor bedrijven die
                doorlopende diensten leveren.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </motion.div>;
}